import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class NavbarScrollMixin extends Vue {
  scrollWidth = 0

  @Ref('topScroll') readonly topScroll!: HTMLElement
  @Ref('tableWrapper') readonly tableWrapper!: HTMLElement

  mounted() {
    this.updateScrollWidth()
    window.addEventListener('resize', this.updateScrollWidth)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollWidth)
  }

  updateScrollWidth() {
    this.$nextTick(() => {
      if (this.tableWrapper) {
        this.scrollWidth = this.tableWrapper.scrollWidth
      }
    })
  }

  onTopScroll(e: Event) {
    if (this.tableWrapper) {
      this.tableWrapper.scrollLeft = (e.target as HTMLElement).scrollLeft
    }
  }

  onTableScroll(e: Event) {
    if (this.topScroll) {
      this.topScroll.scrollLeft = (e.target as HTMLElement).scrollLeft
    }
  }
}